import { useState } from 'react';

const useQuestions = () => {
  const [selectedAnswersIdsByQuestionIdMap, setSelectedAnswersIdsByQuestionIdMap] = useState<{
    [key: number]: string[];
  }>([]);
  const [quizStartTime, setQuizStartTime] = useState(Date.now());
  const collectAnswersIdsByQuestionId = (questionId, getIds) =>
    setSelectedAnswersIdsByQuestionIdMap((oldMap) => ({
      ...oldMap,
      [questionId]: getIds(oldMap[questionId]),
    }));

  const duration = Math.floor((Date.now() - quizStartTime) / 1000).toString();

  return {
    reset: () => {
      setQuizStartTime(Date.now());
      setSelectedAnswersIdsByQuestionIdMap([]);
    },
    duration,
    selectedAnswersIdsByQuestionIdMap,
    collectAnswersIdsByQuestionId,
  };
};

export default useQuestions;
